const TOKEN_KEY = 'access_token'
const USER_INFO_KEY = 'user_info'

// 导入 store（需要在 main.js 中设置）
let store = null

// 设置 store 实例的函数
export function setStore(storeInstance) {
  store = storeInstance
}

// 获取token - 优先从 localStorage，然后从 cookies
export function getToken() {
  // 先从 localStorage 获取
  let token = localStorage.getItem(TOKEN_KEY)
  
  // 如果 localStorage 没有，从 cookies 获取
  if (!token && typeof document !== 'undefined') {
    const cookies = document.cookie.split(';')
    for (let cookie of cookies) {
      const [name, value] = cookie.trim().split('=')
      if (name === TOKEN_KEY) {
        token = decodeURIComponent(value)
        break
      }
    }
  }
  
  // 如果两个地方都没有 token，更新 Vuex 状态为未登录
  if (!token && store) {
    store.commit('setLoginStatus', false)
  }
  
  return token
}

// 设置token - 同时保存到 localStorage 和 cookies
export function setToken(token) {
  localStorage.setItem(TOKEN_KEY, token)
  
  // 同时设置到 cookies（1天过期）
  if (typeof document !== 'undefined') {
    const expires = new Date()
    expires.setTime(expires.getTime() + (24 * 60 * 60 * 1000)) // 1天
    document.cookie = `${TOKEN_KEY}=${encodeURIComponent(token)}; expires=${expires.toUTCString()}; path=/`
  }
  
  // 设置 token 后，更新 Vuex 状态为已登录
  if (token && store) {
    store.commit('setLoginStatus', true)
  }
}

// 移除token - 同时从 localStorage 和 cookies 移除
export function removeToken() {
  localStorage.removeItem(TOKEN_KEY)
  
  // 从 cookies 移除
  if (typeof document !== 'undefined') {
    document.cookie = `${TOKEN_KEY}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/`
  }
  
  // 移除 token 后，更新 Vuex 状态为未登录
  if (store) {
    store.commit('setLoginStatus', false)
  }
}

// 获取用户信息（改为从 Vuex 获取，必要时回退 localStorage）
export function getUserInfo() {
  if (store) {
    return store.getters && store.getters.userInfo !== undefined
      ? store.getters.userInfo
      : store.state && store.state.userInfo
  }
  const raw = localStorage.getItem(USER_INFO_KEY)
  return raw ? JSON.parse(raw) : null
}

// 设置用户信息（改为提交到 Vuex）
export function setUserInfo(userInfo) {
  if (store) {
    store.commit('setUserInfo', userInfo)
    // 设置用户信息通常意味着已登录（视业务而定）
    if (userInfo) {
      store.commit('setLoginStatus', true)
    }
    return
  }
  // 回退：无 store 时，保持原 localStorage 行为
  localStorage.setItem(USER_INFO_KEY, JSON.stringify(userInfo))
}
export function getRoleInfo() {
  if (store) {
    return store.getters && store.getters.roleInfo !== undefined
      ? store.getters.roleInfo
      : store.state && store.state.roleInfo
  }
  const raw = localStorage.getItem(ROLE_INFO_KEY)
  return raw ? JSON.parse(raw) : null
}
export function setRoleInfo(roleInfo) {
  if (store) {
    store.commit('setRoleInfo', roleInfo)
    return
  }
  localStorage.setItem(ROLE_INFO_KEY, JSON.stringify(roleInfo))
}
export function removeRoleInfo() {
  if (store) {
    store.commit('clearRoleInfo')
    return
  }
  localStorage.removeItem(ROLE_INFO_KEY)
}

// 移除用户信息（改为通过 Vuex 清理）
export function removeUserInfo() {
  if (store) {
    store.commit('clearUserInfo')
    store.commit('setLoginStatus', false)
    store.commit('clearRoleInfo')
    return
  }
  localStorage.removeItem(USER_INFO_KEY)
}


// 检查是否已登录
export function isLoggedIn() {
  const hasToken = !!getToken()
  
  // 同步更新 Vuex 状态
  if (store) {
    store.commit('setLoginStatus', hasToken)
  }
  
  return hasToken
}

// 清除所有认证信息
export function clearAuth() {
  removeToken()
  removeUserInfo()
  removeRoleInfo()
  
  // 清除认证信息后，确保 Vuex 状态为未登录
  if (store) {
    store.commit('setLoginStatus', false)
  }
}

// 检查 token 状态并同步 Vuex（可以在应用启动时调用）
export function syncLoginStatus() {
  const hasToken = !!getToken()
  if (store) {
    store.commit('setLoginStatus', hasToken)
  }
  return hasToken
}
